(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    // Get the element with the class pr-share
  const prShareElement = document.querySelector('.pr-share');

  // Get the element with the class tt4s-product__social
  const tt4sProductSocialElement = document.getElementById('pr-social');

  // Add a click event listener to prShareElement
  prShareElement.addEventListener('click', function(event) {
    // Stop the click event from propagating to the document body
    event.stopPropagation();
    // Add the class t4s-dn to tt4sProductSocialElement
    tt4sProductSocialElement.classList.remove('pr-dn');
  });

  // Add a click event listener to the document body
  document.body.addEventListener('click', function() {
    // Remove the class t4s-dn from tt4sProductSocialElement
    tt4sProductSocialElement.classList.add('pr-dn');
  });

  } catch(e) { console.error(e); }
})();
})();
